import {Directive} from '@angular/core';

@Directive({
    selector: '[mposFormGroup]'
})
export class MposFormGroupDirective {}
